import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import {
  ForwardRefExoticComponent,
  KeyboardEventHandler,
  RefAttributes,
  forwardRef,
} from 'react'

interface KZipCodeFieldProps
  extends Omit<KTextFieldProps, 'type' | 'onKeyDown'> {}

export const KZipCodeField: ForwardRefExoticComponent<
  Omit<KZipCodeFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { inputProps, ...restProps } = props

  const handleOnKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Tab' || event.key === 'Backspace') {
      return
    }

    const digit = Number(event.key)
    if (isNaN(digit)) {
      event.preventDefault()
    }
  }

  return (
    <KTextField
      ref={ref}
      onKeyDown={handleOnKeyDown}
      {...restProps}
      inputProps={{
        ...inputProps,
        autoComplete: 'one-time-code',
        maxLength: 5,
      }}
    />
  )
})
